import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder';

export interface SetupGateStepProps {
  accentColor: string;
  onContinue: () => void;
  onSkip: () => void;
}

const SetupGateStep: FC<SetupGateStepProps> = ({ accentColor, onContinue, onSkip }) => {
  const iconBg = `${accentColor}18`;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: 360,
        mx: 'auto',
        py: 2,
      }}
    >
      {/* Icon badge */}
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 3,
          backgroundColor: iconBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <StarBorderIcon sx={{ color: accentColor, fontSize: 28 }} />
      </Box>

      <Typography variant="h5" fontWeight={700} mb={1}>
        One more thing!
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={4} sx={{ lineHeight: 1.7 }}>
        Personalize your experience with a few quick preferences — or skip ahead and jump right in.
      </Typography>

      {/* SUGGESTED label */}
      <Typography
        variant="caption"
        sx={{
          color: accentColor,
          fontWeight: 700,
          letterSpacing: '0.08em',
          mb: 1,
          textTransform: 'uppercase',
        }}
      >
        Suggested
      </Typography>

      <Button
        variant="contained"
        fullWidth
        onClick={onContinue}
        sx={{
          borderRadius: 999,
          py: 1.25,
          fontWeight: 600,
          fontSize: 15,
          mb: 1.5,
          backgroundColor: accentColor,
          boxShadow: 'none',
          '&:hover': { backgroundColor: accentColor, filter: 'brightness(0.9)', boxShadow: 'none' },
        }}
      >
        Continue Setup
      </Button>

      <Button
        variant="outlined"
        fullWidth
        onClick={onSkip}
        sx={{
          borderRadius: 999,
          py: 1.25,
          fontWeight: 600,
          fontSize: 15,
          borderColor: accentColor,
          color: accentColor,
          '&:hover': { borderColor: accentColor, backgroundColor: `${accentColor}0A` },
        }}
      >
        Skip for Now
      </Button>
    </Box>
  );
};

export default SetupGateStep;
